import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c236e400&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c236e400&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c236e400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c236e400')) {
      api.createRecord('c236e400', component.options)
    } else {
      api.reload('c236e400', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c236e400&scoped=true", function () {
      api.rerender('c236e400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exchangeRate/index.vue"
export default component.exports